import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registrarServiceWorker } from './offline/registrarSW';
import './styles.css';

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('No se encontró el nodo #root');
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registrarServiceWorker();
